/**
 * Learning Center URL mapping
 *
 * Maps in-app views and features to their corresponding
 * Learning Center articles at learn.expertmd.io.
 */

const LEARNING_CENTER_BASE = 'https://learn.expertmd.io';

export const LEARNING_CENTER_ARTICLES = {
  // Getting Started
  accountSetup: '/getting-started/account-setup',
  profileCompletion: '/getting-started/profile-completion',
  encryptionSetup: '/getting-started/encryption-setup',

  // Doctor guides
  doctorDashboard: '/doctors/dashboard-overview',
  doctorIntakeForm: '/doctors/intake-form-setup',
  doctorPreScreening: '/doctors/pre-screening-requests',
  doctorCaseManagement: '/doctors/case-management',
  doctorInvoicing: '/doctors/invoicing',
  doctorBilling: '/doctors/billing-and-payouts',
  doctorStripeConnect: '/doctors/stripe-connect',
  doctorTeamMembers: '/doctors/team-members',
  doctorReferral: '/doctors/referral-program',

  // Attorney guides
  attorneyDashboard: '/attorneys/dashboard-overview',
  attorneyClientIntake: '/attorneys/client-intake',
  attorneyIntakeRequests: '/attorneys/intake-requests',
  attorneyCaseManagement: '/attorneys/case-management',
  attorneyInvoicing: '/attorneys/invoicing',
  attorneyPayment: '/attorneys/payment',
  attorneyTeamCollaboration: '/attorneys/team-collaboration',
  attorneyReferral: '/attorneys/referral-program',
  attorneySettings: '/attorneys/settings',

  // Security
  encryptionOverview: '/security/encryption-overview',
  passphraseManagement: '/security/passphrase-management',

  // FAQ
  billingFaq: '/faq/billing-faq',
  casesFaq: '/faq/cases-faq',

  // Changelog
  changelog: '/changelog',
} as const;

export type LearningCenterArticle = keyof typeof LEARNING_CENTER_ARTICLES;

/**
 * Returns the full URL for a learning center article.
 */
export function getLearningCenterUrl(article: LearningCenterArticle): string {
  return `${LEARNING_CENTER_BASE}${LEARNING_CENTER_ARTICLES[article]}`;
}

/**
 * Returns the base learning center URL.
 */
export function getLearningCenterBaseUrl(): string {
  return LEARNING_CENTER_BASE;
}
